import useExcepcion from '../../../shared/hooks/useExcepcion';
import { getProductosRecomendados } from '../repository/productoRepository';
import { useState, startTransition } from 'react';

const useRecomendacion = () => {
    const [ loader, setLoader ] = useState(false);
    const [ productos, setProductos ] = useState([]);
    const { handleMessageException } = useExcepcion();

    const handleGetProducts = async (codigo, sucursal) => {
        try {
            setLoader(true);
            startTransition(() => {
                getProductosRecomendados({
                    CodigoProducto: codigo,
                    CodigoSucursal: sucursal,
                })
                .then(res => {
                    setProductos(res);
                }).catch((err) => {
                    setProductos([]);
                    handleMessageException(err);
                }).finally(() => {
                    setLoader(false);
                });
            });
        } catch(err) {
            handleMessageException(err);
        }
        return [];
    }

    return { loader, productos, handleGetProducts };
}

export default useRecomendacion;